import {FormErrorType} from '@sharedComponents/PantaForm/types';
import {
    appendError,
    removeError,
    validateIsZipCode,
    validateRequired,
} from '@sharedComponents/PantaForm/utils';
import i18n from '@apps/Shared/translation/i18n';
import { SwishFormValues, OrgNumberValidationObject } from './types';

export function validateOrgNr(
    orgNumber: string
) {
    let orgNumberValidation: OrgNumberValidationObject = {
        isValid: false,
        errors: []
    };

    const errors = validateRequired(
        orgNumber,
        'orgNumber',
        i18n.t('error.emptyOrgnr'),
        orgNumberValidation.errors
    );

    if (errors.length > 0) {
        orgNumberValidation.errors = errors;
        return orgNumberValidation;
    }

    if (orgNumber.length !== 10) {
        orgNumberValidation.isValid = false;
        orgNumberValidation.errors = [
            {
                key: 'orgNumber',
                messages: [i18n.t('swishform.incorrectOrgnrLength')]
            }
        ];

        return orgNumberValidation;
    }

    orgNumberValidation.isValid = true;
    return orgNumberValidation;
}
export function validateCompanyName(
    companyName: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        companyName,
        'companyName',
        i18n.t('error.emptyCompanyName'),
        currentErrors
    );
    return errors;
}
export function validateCity(
    city: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        city,
        'companyCity',
        i18n.t('error.emptyCity'),
        currentErrors
    );
    return errors;
}
export function validateStreetAddress(
    streetAddress: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        streetAddress,
        'companyStreet',
        i18n.t('error.emptyStreetAddress'),
        currentErrors
    );
    return errors;
}
export function validateZipCode(
    zipCode: string,
    currentErrors: FormErrorType[]
) {
    let errors = [...currentErrors];
    errors = validateRequired(
        zipCode,
        'companyZipcode',
        i18n.t('error.emptyZipCode'),
        errors
    );
    if (zipCode) {
        errors = validateIsZipCode(
            zipCode,
            'companyZipcode',
            i18n.t('error.incorrectZipCode'),
            errors
        );
    }
    return errors;
}
export function validateName(
    name: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        name,
        'signerName',
        i18n.t('error.emptyName'),
        currentErrors
    );
    return errors;
}
export function validatePhone(
    phone: string,
    currentErrors: FormErrorType[]
) {
    const errors = validateRequired(
        phone,
        'signerPhone',
        i18n.t('error.emptyPhoneNumber'),
        currentErrors
    );
    return errors;
}
export function validateEmail(
    email: string,
    currentErrors: FormErrorType[]
) {
    let errors = validateRequired(
        email,
        'signerEmail',
        i18n.t('error.emptyEmail'),
        currentErrors
    );
    if (!_validateEmail(email)) {
        errors = appendError(errors, 'signerEmail', i18n.t('error.incorrectEmail'));
    } else {
        errors = removeError(errors, 'signerEmail', i18n.t('error.incorrectEmail'));
    }
    return errors;
}
function _validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export function validateForm(
    values: SwishFormValues,
    currentErrors: FormErrorType[]
) {
    let errors = [...currentErrors];
    errors = validateCompanyName(values.companyName, errors);
    errors = validateCity(values.companyCity, errors);
    errors = validateStreetAddress(values.companyStreet, errors);
    errors = validateZipCode(values.companyZipcode, errors);
    errors = validateName(values.signerName, errors);
    errors = validatePhone(values.signerPhone, errors);
    errors = validateEmail(values.signerEmail, errors);
    return errors;
}
